module.exports = __webpack_public_path__ + "static/media/cert_part3_nova.ea07f965.png";